import { ConstructClassWithPrivateMembers } from '../helpers/ClassWithPrivateMembers';
import { IsObject } from '../../helpers';
export const READONLY_SET_PRIVATE = Symbol('readonly-set-private');
export function ConstructReadonlySet(instance, iterable) {
    ConstructClassWithPrivateMembers(instance, READONLY_SET_PRIVATE);
    const privates = instance[READONLY_SET_PRIVATE];
    if (iterable instanceof Set) {
        privates.set = iterable;
    }
    else if (Symbol.iterator in iterable) {
        privates.set = new Set(iterable);
    }
    else {
        throw new TypeError(`Expected Iterable<[TValue]> as entries`);
    }
}
export function IsReadonlySet(value) {
    return IsObject(value)
        && value.hasOwnProperty(READONLY_SET_PRIVATE);
}
export class ReadonlySet {
    constructor(iterable) {
        ConstructReadonlySet(this, iterable);
    }
    get size() {
        return this[READONLY_SET_PRIVATE].set.size;
    }
    forEach(callback, thisArg = this) {
        return this[READONLY_SET_PRIVATE].set.forEach(callback, thisArg);
    }
    has(value) {
        return this[READONLY_SET_PRIVATE].set.has(value);
    }
    entries() {
        return this[READONLY_SET_PRIVATE].set.entries();
    }
    keys() {
        return this[READONLY_SET_PRIVATE].set.keys();
    }
    values() {
        return this[READONLY_SET_PRIVATE].set.values();
    }
    [Symbol.iterator]() {
        return this[READONLY_SET_PRIVATE].set[Symbol.iterator]();
    }
}
//# sourceMappingURL=implementation.js.map